
// Generated by dayjs-nuxt-module
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'

import 'dayjs/locale/en'
import 'dayjs/locale/pt'
import 'dayjs/locale/fr'
import 'dayjs/locale/es'
import 'dayjs/locale/ca'
import 'dayjs/locale/it'
import 'dayjs/locale/nl'
import 'dayjs/locale/de'
import relativeTime from 'dayjs/plugin/relativeTime'
import arraySupport from 'dayjs/plugin/arraySupport'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'


dayjs.extend(updateLocale)

dayjs.extend(relativeTime)
dayjs.extend(arraySupport)
dayjs.extend(isBetween)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(utc)
dayjs.extend(timezone)

dayjs.tz.setDefault('Europe/Lisbon')

// defaultLocale: "pt"


dayjs.updateLocale("pt")
dayjs.locale('pt')


export default dayjs
